import type { ComponentType } from 'react';
import type { Question, ResponsePayload } from '../../../types';

export interface QuestionRendererExtras {
  audioBlob?: Blob | null;
  horizontalState?: {
    leftIds: number[];
    middleIds: number[];
    rightIds: number[];
    correctColumnById: Record<number, 'left' | 'right'>;
  };
  isVideoValid?: boolean;
  isPdfValid?: boolean;
  isAiSummaryLoading?: boolean;
}

export interface QuestionRendererProps {
  question: Question;
  existingResponse?: ResponsePayload;
  isSubmitting: boolean;
  isQuizFlow?: boolean;
  flowRunId?: number | null;
  onDraftChange(draft: ResponsePayload | null): void;
  onHasUserInputChange?(hasInput: boolean): void;
  onValidityChange?(isValid: boolean): void;
  onExtrasChange?(extras: QuestionRendererExtras): void;
}

export type QuestionRendererComponent = ComponentType<QuestionRendererProps>;

const registry = new Map<string, QuestionRendererComponent>();

export const registerQuestionRenderer = (types: string[], component: QuestionRendererComponent) => {
  types.forEach((type) => {
    const normalized = type.toLowerCase();
    registry.set(normalized, component);
  });
};

export const getQuestionRenderer = (type: string | undefined | null): QuestionRendererComponent | undefined => {
  if (!type) {
    return undefined;
  }

  return registry.get(type.toLowerCase());
};
